module.exports = __webpack_public_path__ + "img/2-4.2a9ca714.png";